import React from 'react'
import styled, { css } from 'styled-components'
import PropTypes from 'prop-types'
import Theme from 'components/common/Theme/Theme'
import PhoneLink from 'components/common/PhoneLink'
import Media from 'components/common/Media'

const ProductItem = ({
  freeAlignmentCheckDisabled,
  freeAligmentTooltip,
  product: {
    brandImageUrl,
    productName,
    description,
    qty,
    totalPrice
  },
  formattedStorePhoneNumber,
  storePhoneNumber
}) =>
  <Item data-at-appointment-product>
    <Logo data-at-appointment-product-logo src={ `${brandImageUrl}?$BOT-MyAppointments-Tire-Brand-w110-alpha$` } />

    <InfoWrapper>
      <div>
        <TireName data-at-appointment-product-name>{ productName }</TireName>
        <Size data-at-appointment-product-size>{ description }</Size>
        <Quantity>{`Qty:${qty}`}</Quantity>
      </div>

      <PriceWrapper totalPrice={ totalPrice }>
        {(totalPrice && Number(totalPrice) > 0)
          ? <>
            Price: <Price>{`$${totalPrice}`}</Price>
          </>
          : <>
            <Text>Call store for price</Text>

            <Media.Mobile>
              <StyledPhoneLink number={ formattedStorePhoneNumber } />
            </Media.Mobile>
            <Media.Desktop>
              <CallStore>{ storePhoneNumber }</CallStore>
            </Media.Desktop>
          </>
        }

      </PriceWrapper>
    </InfoWrapper>

    {!freeAlignmentCheckDisabled && (
      <AlignmentTooltip>
        <TooltipName>{freeAligmentTooltip.name}</TooltipName>
        <TooltipDescription>{freeAligmentTooltip.description}</TooltipDescription>
      </AlignmentTooltip>
    )}
  </Item>

ProductItem.propTypes = {
  formattedStorePhoneNumber: PropTypes.string,
  freeAligmentTooltip: PropTypes.shape(),
  freeAlignmentCheckDisabled: PropTypes.bool,
  product: PropTypes.shape(),
  storePhoneNumber: PropTypes.string
}

export default ProductItem

const Item = styled.li`
  position: relative;
  padding: 24px 0 24px 0;
`

const Logo = styled.img`
  margin: 0 0 8px 0;
`

const InfoWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 1023px) {
    flex-direction: column;
  }
`

const TireName = styled.p`
  margin: 0 0 8px 0;
  font-size: 16px;
  line-height: 1.2;
`

const Size = styled(TireName)`
  font-size: 14px;
`

const Quantity = styled(Size)`
  margin: 0;

  @media (max-width: 1023px) {
    margin: 0 0 8px 0;
  }
`

const PriceWrapper = styled.div`
  display: flex;
  margin: 0;
  font-size: 14px;
  ${props => ((props.totalPrice && Number(props.totalPrice) <= 0) && css`
    flex-direction: column
  `)}

  @media (max-width: 1023px) {
    align-items: flex-end;
  }
`

const Price = styled(TireName)`
  margin: 0 0 0 4px;
  font-weight: 700;
`

const AlignmentTooltip = styled.div`
  padding: 12px;
  margin: 24px 0 0 0;
  background: ${Theme.colors.pale_yellow};
`

const TooltipName = styled.p`
  margin: 0;
  font-size: 12px;
  line-height: 1.2;
  font-weight: 700;
`

const TooltipDescription = styled(TooltipName)`
  font-weight: 400;
`

const Text = styled.p`
  margin: 0;
  font-size: 14px;
  line-height: 1.2;
`

const CallStore = styled.p`
  display: block;
  margin: 0;
  font-weight: 700;
  line-height: 1.2;
  font-size: 14px;
  text-align: end;

  @media (max-width: 1023px) {
    text-align: start;
  }
`

const StyledPhoneLink = styled(PhoneLink)`
  display: block;
  text-decoration: none;
  font-weight: 700;
  line-height: 1.2;
  font-size: 14px;
  text-align: end;
`
